let JsLingua = require("jslingua");
let engMorpho = JsLingua.nserv("morpho", "eng");
import {
  VERB_TENSES,
  VERB_CATEGORY,
  VERB_PERSON,
  VERB_NUMBER,
  VOWELS,
  SAMPLE_VERBS,
  VERB_FORMS
} from "@/constants.js";

import {
    conjugate,
    generateStem,
    enumerateConjugations,
    allFormsOfWord,
    removeAsterisk
  } from "@/conjugation.js";

  export function translateConjugationPrompt(prompt){
    var tempWord = "";
    for (var i = 0; i < SAMPLE_VERBS.length; i++){
      if (prompt.verb == SAMPLE_VERBS[i].verb){
      tempWord = SAMPLE_VERBS[i].translation;
      }
    }
    return conjugateTable(tempWord, prompt, prompt.number, prompt.person);
  }

  export function translateTable(prompt){
    var tempWord = "";
    for (var i = 0; i < SAMPLE_VERBS.length; i++){
      if (prompt.verb == SAMPLE_VERBS[i].verb){
      tempWord = SAMPLE_VERBS[i].translation;
      }
    }
    var result = [];
    Object.values(VERB_NUMBER).forEach(num => {
      Object.values(VERB_PERSON).forEach(person => {
      result.push(conjugateTable(tempWord, prompt, num, person));
      });
    });
    console.log(result);
    return result;
  }

  export function conjugateTable(verb, prompt, num, person) {
    var persontemp = ""; // rename persontemp
    var pronoun = ""; //I, you, he, she, they...
    var prefix = ""; //do, did, will, would...
    var suffix = ""; // when interrogative, ?

    var isNegated = 0; // set negation bool
    if(prompt.depForm == VERB_FORMS.negative){
      isNegated = 1;
    }

    if(prompt.depForm == VERB_FORMS.interrogative){ // setting prefix
      suffix = "?";
      if(prompt.tense == "past" || prompt.tense == "habitual"){
        prefix = "did ";
      }else if(prompt.tense == "present"){
        prefix = "do ";
        if (person == "3rd Person" && num == "singular"){ 
          prefix = "does "}
      }else if(prompt.tense == "future"){
        prefix = "will ";
      }else if(prompt.tense == "conditional"){
        prefix = "would ";
      }
    }

    // * generate regular pronouns * //
    if(num == "singular"){ // generate singular pronouns
      if(person == "1st Person"){
        persontemp = "first";
        pronoun = "I";
      }else if(person == "2nd Person"){
        persontemp = "second";
        pronoun = "you";
      }else{
        persontemp = "third";
        pronoun = "he/she/it";
      }
    }else{ // generate plural pronouns
      if(person == "1st Person"){ 
        persontemp = "first";
        pronoun = "we";
      }else if(person == "2nd Person"){
        persontemp = "second";
        pronoun = "you all";
      }else{
        persontemp = "third";
        pronoun = "they";
      }
    }

    // * special cases * //
    if(prompt.tense == "present subjunctive"){
      prefix = "may ";
    }else if(prompt.tense == "imperative"){
      prefix = "let ";
      if(person == "3rd Person" && num == "plural"){
        pronoun = "them";
      }
      if(person == "1st Person" && num == "singular"){
        pronoun = "me";
      }
      if(person == "1st Person" && num == "plural"){
        pronoun = "us";
      }
    }

    var opts = { //set opts
      tense: prompt.tense,
      person: persontemp,
      number: num,
    };
    opts.negated = isNegated;

    //! Existing bugs:
    //* Future Interrogative: "Will I will verb?"
    //* Past Interrogative: "Did I judged?"

    // "unconjugated" form of verb when it's a question
    if(prompt.depForm == "interrogative" || prompt.tense == "conditional"){
      opts.tense = "Present";
      opts.person = "first"
    }

    if(prompt.tense == "conditional"){
      if(prompt.depForm == "interrogative"){
          var answer = "would " + pronoun + " " + engMorpho.conj(verb,opts) + suffix;
        }else{
          var answer = pronoun + " would " + engMorpho.conj(verb,opts) + suffix;
        }
    }else if(prompt.tense == "habitual"){
      var answer = prefix + pronoun + " used to " + engMorpho.conj(verb,opts) + suffix;
    }else{
      var answer = prefix + pronoun + " " + engMorpho.conj(verb, opts) + suffix;
    }

    if(isNegated){
      if(prompt.tense != "present" &&
        prompt.tense != "past"){ //if tense is future, conditional, habitual, or imperative...
          answer = answer.replace('do','');
        }
    }

    answer = answer.charAt(0).toUpperCase() + answer.slice(1); // capitalize first letter
    return answer;
    
}